/**
 * 分类菜单组件
 * 提供产品分类、详细分类等层级菜单功能
 * 
 * @module common/components/CategoryMenu
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;

  /**
   * 分类菜单组件
   * @class CategoryMenu
   * 
   * @example
   * new watashi.common.CategoryMenu({
   *   mainContainer: '#product_category_main',
   *   hoverClass: 'hover',
   *   container: '.category-container',
   *   button: '.category-container > .classification',
   *   subContainer: '.category-container > .sub-category'
   * });
   */
  common.CategoryMenu = (function () {
    const defaults = {
      mainContainer: '',
      container: '.category-container',
      button: '.classification',
      subContainer: '.sub-category',
      subCategory: '.sub-name',
      hoverClass: 'hover',
    };

    /**
     * 创建分类菜单实例
     * @param {Object} options - 配置选项
     */
    function CategoryMenu(options) {
      this.settings = {...defaults, ...options};
      this.init();
    }

    const _category = CategoryMenu.prototype;

    /**
     * 初始化菜单
     */
    _category.init = function () {
      if (common.exists(this.settings.mainContainer) && common.exists(this.settings.container)) {
        this.bindEvents();
      }
    };

    /**
     * 绑定事件
     */
    _category.bindEvents = function () {
      const configs = this.settings;
      const buttons = document.querySelectorAll(configs.button);
      buttons.forEach(button => {
        common.registerEvent(button, 'click', common.toggleMenu.bind(this, {
          nameSelector: configs.button,
          containerSelector: configs.subContainer,
          hoverClass: this.settings.hoverClass,
        }));
      });
    };

    /**
     * 修复加载时的显示问题
     * @param {number} [index=6] - 要修复的按钮索引
     */
    _category.fixOnLoad = function (index = 6) {
      const dom = document.querySelectorAll(this.settings.button)[index];
      if (dom) {
        dom.innerHTML = dom.innerHTML.replace('·', '<br/>');
      }
    };

    return CategoryMenu;
  })();

})(typeof window !== "undefined" ? window : this);
